import { Link } from "react-router-dom";

const ROLE_LABELS = { super_admin: "Super Admin", hr_admin: "HR/Admin" };
const roleLabel = (r) => ROLE_LABELS[r] || "Employee";

export const EmployeeTable = ({ list }) => (
  <div className="bg-white border border-stone-200 rounded-lg overflow-x-auto">
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left text-xs uppercase tracking-wide text-stone-500 border-b border-stone-200">
          <th className="px-6 py-4">Employee</th>
          <th className="px-6 py-4 hidden md:table-cell">Code</th>
          <th className="px-6 py-4 hidden md:table-cell">Department</th>
          <th className="px-6 py-4 hidden lg:table-cell">Designation</th>
          <th className="px-6 py-4">Role</th>
          <th className="px-6 py-4">Status</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-stone-100">
        {list.map((e) => (
          <tr key={e.id} className="hover:bg-stone-50 transition-colors duration-150">
            <td className="px-6 py-4">
              <Link to={`/admin/employees/${e.id}`} data-testid={`employee-row-${e.id}`} className="font-semibold text-stone-900 hover:text-primary transition-colors duration-150">{e.name}</Link>
              <div className="text-xs text-stone-500">{e.email}</div>
            </td>
            <td className="px-6 py-4 hidden md:table-cell tabular-nums">{e.employee_code}</td>
            <td className="px-6 py-4 hidden md:table-cell">{e.department}</td>
            <td className="px-6 py-4 hidden lg:table-cell">{e.designation}</td>
            <td className="px-6 py-4"><span className="text-xs font-bold px-2.5 py-1 rounded-full bg-stone-100">{roleLabel(e.role)}</span></td>
            <td className="px-6 py-4"><span className={`text-xs font-bold px-2.5 py-1 rounded-full ${e.status === "active" ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"}`}>{e.status}</span></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
